import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';
import * as yup from 'yup';

export default [
  {
    name: 'user',
    label: i18n('entities.userEntitlement.fields.user'),
    schema: schemas.relationToOne(
      i18n('entities.userEntitlement.fields.user'),
      {},
    ),
  },
  {
    name: 'entitlement',
    label: i18n(
      'entities.userEntitlement.fields.entitlement',
    ),
    schema: schemas.relationToOne(
      i18n('entities.userEntitlement.fields.entitlement'),
      {
        required: true,
      },
    ),
  },
  {
    name: 'active',
    label: i18n('entities.userEntitlement.fields.active'),
    // Default to active when omitted/blank in import rows.
    schema: yup
      .bool()
      .transform((cv, ov) => {
        if (ov === '' || ov === null || ov === undefined) {
          return true;
        }
        return cv;
      })
      .default(true)
      .label(i18n('entities.userEntitlement.fields.active')),
  },
];
